export default __webpack_public_path__ + "static/media/bg-8.55c328ef.jpg";